import React from "react";
import {Helmet} from "react-helmet";
import { IPage } from "../interfaces/IPage";
import CmsGrid from "./CmsGrid";
import ContentSection from "../../cmp/page/ContentSection";
import { useCmsData } from "../../hooks/useCmsData";
import LoadingSpinner from "../../cmp/page/LoadingSpinner";

interface Props {
    id: string,
    language: ("de" | "en")
}

const CmsPage : React.FC<Props> = ({id, language}) => {
    const [pages, loading, error] = useCmsData<Array<{"_translations": Array<IPage>}>>({ docId: id, fields: `"_translations": *[_type == "translation.metadata" && references(^._id)].translations[].value->{
    pageTitle,
    pageDescription,
    language,
    content,
    robots,
    relativeUrl
  }`});
  
    const {pageTitle, pageDescription, content, robots} = pages?.[0]._translations?.find(p => p.language === language)??{} as IPage;
    return <>
        <Helmet>
            <title>{pageTitle}</title>
            <meta name="description" content={pageDescription} />
            <meta name="robots" content={robots} />
            {pages?.[0]._translations?.filter(fp => fp?.language !== language).map(page => <link rel="alternate" hrefLang={page?.language} href={page?.relativeUrl} title={page?.pageTitle} />)}
        </Helmet>
        {!loading && !error && <ContentSection>
            {content && <CmsGrid {...content} />}
        </ContentSection>}
        {loading === true && <LoadingSpinner />}
    </>
}

export default CmsPage;